import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchResult } from '../search-result';
import { ConstantsService } from '../Services/constants.service';
import { HttpClientRequestService } from '../Services/http-client-request.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
 
  keyword: string;
  inputBody: any;
  serachResult = {} as SearchResult;
  paginationCount: number;
  pagination: number[];
  pageNo: number;  
 
  constructor(private elementRef: ElementRef,private route: ActivatedRoute, 
    private _httpClientRequestService: HttpClientRequestService,
    private _constantsService: ConstantsService) {
    
    this.route.params.subscribe(params => {     
      this.keyword  = this.route.snapshot.params.query;
      this.pageNo = this.route.snapshot.params.pageno;  
      if(this.keyword != undefined && this.pageNo > 0){
        this.loadSearch();
      }      
    });

   }

  ngOnInit() {    
 
  }

  loadSearch(){

    this.inputBody = {
      "Keyword": this.keyword,
      "PageNo": this.pageNo,
      "SinequaSearchURL": this._constantsService.SinequaSearchURL,
      "SinequaSearchProfile": this._constantsService.SinequaSearchProfile,
      "SinequaSearchCollection": this._constantsService.SinequaSearchCollection      
     }

    this._httpClientRequestService.Post(this._constantsService.senequaEndpoint,this.inputBody).subscribe(Response=>{
      this.serachResult = Response;  
      if(this.serachResult.TotalCount > 0){
      this.paginationCount = Math.ceil(this.serachResult.TotalCount/10);
      this.pagination = Array(this.paginationCount).fill(0).map((x,i)=>i);      
      }
    });
  }

}
